<template>
  <div class="landing">

      <v-layout class="first flex-grow-1">
          <v-container>
                <v-row align="center" justify="center" class="bglight">

                    <img :src="$config.imagepath+'transferpass.jpg'" alt="" style="max-width: 100%;"/>

                </v-row>
                <v-row>
                      <v-col class="wrap" cols="12" xl="6" lg="6" sm="12" md="6" offset-xl="1">                        
                      <h1 class="page-title">Impressum</h1>
                      <p class="bodytext"><strong>Technische Hochschule Wildau</strong><br> Hochschulring 1<br> 15745 Wildau</p>
                      <p class="bodytext">Tel: +49 (0) 3375 / 508 -&nbsp;300 (Telefonzentrale)<br> E-Mail: <a href="javascript:linkTo_UnCryptMailto(%27kygjrm8fmafqafsjimkkslgiyrgmlYrf%2Bugjbys%2Cbc%27);">hochschulkommunikation(at)th-wildau.de</a></p>
                      <p class="bodytext">Vertreten durch:</p>
                      <p class="bodytext">Die Technische Hochschule Wildau ist eine Körperschaft des öffentlichen Rechts. Sie wird nach außen durch die <strong>Präsidentin, Prof. Dr. Ulrike Tippe</strong>, vertreten.</p>
                      <p>Umsatzsteuer:&nbsp;</p>
                      <p>Umsatzsteuer-Identifikationsnummer gemäß §27a Umsatzsteuergesetz: DE138549391</p>
                      <p>Zuständige Aufsichtsbehörde:</p>
                      <p class="bodytext">Die Hochschule untersteht der Rechtsaufsicht des Ministeriums für Wissenschaft, Forschung und Kultur des Landes Brandenburg.</p>
                      <p class="Ueberschrift-2">Haftung für Inhalte</p>
                      <p class="bodytext">Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.</p>
                      <p class="bodytext">Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.</p>
                      <p class="Ueberschrift-2">Haftung für Links</p>
                      <p class="bodytext">Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.</p>
                      <p class="bodytext">Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.</p>
                      <p class="Ueberschrift-2">Urheberrecht</p>
                      <p class="bodytext">Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.</p>
                      <p class="bodytext">Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.</p>
                      <p class="Ueberschrift-2">Datenschutz</p>
                      <p class="bodytext"><a href="/datenschutz" target="_self">Zur Datenschutzerklärung</a></p>
                      </v-col>
                      <v-col cols="4" xl="4" md="4" lg="4" sm="12" class="sidebar blanc">
                        <div>
                        </div>
                      </v-col>
                </v-row>
                <v-row align="center">
                      <v-col cols="12" xl="8" md="12" lg="11" sm="12" offset-xl="1">
                     </v-col>
                </v-row>
          </v-container>
      </v-layout>

      <Footer></Footer>

  </div>

</template>

<script>

//import Setting from '../components/footer/Setting';
// import Contact from '../components/elements/Contact';
import Footer from './elements/Footer';

export default {
  name: 'Admin',

  components: {
    // Contact,
    Footer
  },
  props: {    
    template: String
  },  
  data() {
    return {
      lorem: 'xxx',
      host: window.location.host,
      contacts: null
    }
  },
  created: function() {

    this.getHome();
  
    if(this.template == 'icampus') {
      setTimeout(this.fireStart, 100);      
      this.fireStart('icampus');
    } else if ( this.template == 'innoxr') {
      setTimeout(this.fireStart, 100);      
      this.fireStart('innoxr');      
    }

  },
  methods: {    
    getHome() {    
        let self = this;
        this.axios.get( this.$config.host+"/resps" ).then(function (response) {
          //console.log("get HOME filter");                                            
          self.contacts = response.data.filter(r => r.category === 3 );
        });
    },
    fireStart(template) {

      switch (template) {
        case 'icampus':
            this.$router.push({ name: 'PanoramaFrame' }, () => {} );                  
          break;

        case 'innoxr':
            this.$router.push({ name: 'Virtuell' }, () => {} );                
          break;

      }                        

    }

  }
};
</script>

<style scoped>
.landing {
  height:100%;
  background-color: #ffffff;
}

.region {
  position:relative;
  margin-top:0px;
  text-align:center;
}
.region button,
.region a {
  position:absolute;
  box-shadow:none;
}
.welcome {
  color:#fff;
}
.btn {
  padding:14px 20px;
  border:1px solid #fff;
  border-radius:6px;
  margin-right:20px;
  margin-bottom:20px;
  color:#fff;
}
.bordertop {
  border-top:2px solid #000;
}
#s01 {
  top:62%;
  left:62%
}
#s02 {
  top:20%;
  left:52%
}

</style>

<style>

.layout.first {
  padding-top:60px;
  padding-bottom:20px;
}
.container {
  background-color:transparent;
  max-width:1560px;
}
.container.topic {
  background-color:transparent;
}
.container .row {
  padding-top:0px;
}
.wrap img {
  max-width:100%;
}

.servicewrap {
  padding-top:40px;
  padding-bottom:40px;
}
.servicewrap .row {
  padding-top:10px;
}
.servicewrap p > img {
  margin-right: 2rem;
}
</style>
